// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flip-card {
  perspective: 1200px;
  cursor: pointer;
  position: relative;
}

.flip-inner {
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 0.8s ease-in-out;
  transform-style: preserve-3d;
  transform-origin: center center;
}

.flip-card.flipped .flip-inner,
.flip-card.hover-flip:hover .flip-inner {
  transform: rotate3d(-1, 1, 0, 180deg);
}

.flip-front,
.flip-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
}

.flip-front {
  font-size: inherit;
}

.flip-back {
  transform: rotate3d(-1, 1, 0, 180deg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/FlipCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,uCAAuC;EACvC,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".flip-card {\n  perspective: 1200px;\n  cursor: pointer;\n  position: relative;\n}\n\n.flip-inner {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition: transform 0.8s ease-in-out;\n  transform-style: preserve-3d;\n  transform-origin: center center;\n}\n\n.flip-card.flipped .flip-inner,\n.flip-card.hover-flip:hover .flip-inner {\n  transform: rotate3d(-1, 1, 0, 180deg);\n}\n\n.flip-front,\n.flip-back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  backface-visibility: hidden;\n  overflow: hidden;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n  top: 0;\n  left: 0;\n}\n\n.flip-front {\n  font-size: inherit;\n}\n\n.flip-back {\n  transform: rotate3d(-1, 1, 0, 180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
